export const adrift = {
  title: 'Adrift',
  image: '/Adrift.jpg',
  note: 'A forgotten night. A stolen bag. A desperate escape. Cora flees to the Philippines, haunted by gaps in her memory and a military duffle bag she is too afraid to open.',
  url: 'https://www.walmart.com/ip/Adrift-Paperback/21157460843?classType=REGULAR',
  // November 6, 2026 at midnight in America/Chicago (CST).
  releaseAt: Date.parse('2026-11-06T00:00:00-06:00')
};

export const bibleBookUrl = 'https://www.walmart.com/ip/Who-Wrote-the-First-Book-of-the-Christian-Bible-And-why-did-they-do-it-Paperback-9798992611038/21080520768?classType=REGULAR';

export const isAdriftAvailable = (now = Date.now()) => now >= adrift.releaseAt;
